import { useAppSelector } from "app/hooks";
import { Tooltip } from "components/Tooltips/Tooltip";
import { useMessage } from "hooks/intl";
import { selectDefaultLanguageData } from "reduxState/translations/translationsSlice";
import { handleBooleanValue } from "utilities/strings";
import { useStyles } from "./styles";

interface Props {
  name: string;
  description: string;
  isActive: boolean;
}

export const BasicSettings = ({ name, description, isActive }: Props) => {
  const { message } = useMessage();
  const classes = useStyles();
  const defaultLang = useAppSelector(selectDefaultLanguageData);

  return (
    <section className={classes.boxWrapper}>
      <header className={classes.header}>
        {message({ id: "basicSettings" })}
      </header>
      <div className={classes.item}>
        <span className={classes.itemName}>{message({ id: "tierName" })}</span>
        <div className={classes.itemValue}>
          <Tooltip text={name}>
            <span>{name}</span>
          </Tooltip>
        </div>
      </div>
      <div className={classes.item}>
        <span className={classes.itemName}>
          {`${message({ id: "tierDescription" })} (${defaultLang.name})`}
        </span>
        <div className={classes.itemValue}>
          <Tooltip text={description}>
            <span>{description}</span>
          </Tooltip>
        </div>
      </div>
      <div className={classes.item}>
        <span className={classes.itemName}>
          {`${message({ id: "active" })}`}
        </span>
        <div className={classes.itemValue}>
          <span>{message({ id: handleBooleanValue(isActive) })}</span>
        </div>
      </div>
    </section>
  );
};
